import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import useProductContent from '@/composables/useProductContent/useProductContent';
import { UseCheckCanDisplayComponent } from '@/composables/useCheckCanDisplayComponent';
export var IAdvancedTabsItem;
export default defineComponent({
  name: 'AdvancedTabsItem',
  components: {
    RenderContent: function RenderContent() {
      return import('~/components/cms/page/RenderContent.vue');
    }
  },
  props: {
    title: String,
    sectionTitle: String,
    contents: Array,
    catchphrase: String,
    isInTabContainer: Boolean,
    lastTabContentsLastElement: Object
  },
  setup: function setup(props) {
    var isRecipePage = inject('isRecipePage', false);
    var _useProductContent = useProductContent(),
      mapComponentName = _useProductContent.mapComponentName;
    var components = computed(function () {
      return props.contents ? mapComponentName(props.contents, {
        tabTitle: props.title,
        tabCatchphrase: props.catchphrase,
        isRecipePage: isRecipePage
      }).filter(function (_ref) {
        var fields = _ref.fields;
        return canDisplayComponent(fields);
      }) : null;
    });
    provide('fieldName', 'tab');
    var canDisplayComponent = function canDisplayComponent(comp) {
      return UseCheckCanDisplayComponent(comp);
    };
    var hideUnderline = function hideUnderline(comp) {
      if (!comp.fields.displayOptions) {
        return false;
      }
      return comp.fields.displayOptions.some(function (option) {
        var _option$fields;
        return (option === null || option === void 0 ? void 0 : (_option$fields = option.fields) === null || _option$fields === void 0 ? void 0 : _option$fields.value) === 'green-clickable-block-list';
      });
    };
    var isBlockExpandableTab = function isBlockExpandableTab(component) {
      var _component$fields;
      return (component === null || component === void 0 ? void 0 : (_component$fields = component.fields) === null || _component$fields === void 0 ? void 0 : _component$fields.component) === 'BlockExpandableTab';
    };
    return {
      components: components,
      canDisplayComponent: canDisplayComponent,
      hideUnderline: hideUnderline,
      isBlockExpandableTab: isBlockExpandableTab
    };
  }
});